import script from "./TrackMasterclass.vue?vue&type=script&setup=true&lang=js"
export * from "./TrackMasterclass.vue?vue&type=script&setup=true&lang=js"

import "./TrackMasterclass.vue?vue&type=style&index=0&id=256d3bc1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256d3bc1"]])

export default __exports__